import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

/**
 * Reusable confirmation before removing a scanned bundle from a draft.
 * Pass the target barcode (or null when closed); confirming calls onConfirm.
 */
export const ConfirmRemoveBundleDialog = ({
  barcode,
  onConfirm,
  onCancel,
  itemLabel = 'bundle',
}) => {
  const open = !!barcode;
  return (
    <AlertDialog open={open} onOpenChange={(o) => { if (!o) onCancel?.(); }}>
      <AlertDialogContent data-testid="remove-bundle-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Remove {itemLabel}?</AlertDialogTitle>
          <AlertDialogDescription>
            Remove <span className="font-mono font-semibold">{barcode}</span> from the draft? This just takes it off the current list — it is not deleted from the system.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="remove-bundle-cancel-btn" onClick={() => onCancel?.()}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid="remove-bundle-confirm-btn"
            onClick={() => onConfirm?.()}
            className="bg-red-600 hover:bg-red-700"
          >
            Remove
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ConfirmRemoveBundleDialog;
